/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiStatisticsTracksQueryResponse, GetApiStatisticsTracksQueryParams, GetApiStatisticsTracks400, GetApiStatisticsTracks401, GetApiStatisticsTracks403, GetApiStatisticsTracks500 } from "../../types/GetApiStatisticsTracks.ts";
import { getApiStatisticsTracksQueryResponseSchema } from "../../zod/AdminStatisticsSchemas/getApiStatisticsTracksSchema.ts";

function getGetApiStatisticsTracksUrl() {
  const res = { method: 'GET', url: `/api/statistics/tracks` as const }  
  return res
}

/**
 * @summary Получение статистики по трекам
 * {@link /api/statistics/tracks}
 */
export async function getApiStatisticsTracks({ params }: { params: GetApiStatisticsTracksQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiStatisticsTracksQueryResponse, ResponseErrorConfig<GetApiStatisticsTracks400 | GetApiStatisticsTracks401 | GetApiStatisticsTracks403 | GetApiStatisticsTracks500>, unknown>({ method : "GET", url : getGetApiStatisticsTracksUrl().url.toString(), params, ... requestConfig })  
  return getApiStatisticsTracksQueryResponseSchema.parse(res.data)
}